const LICENSE_API =
  process.env.REACT_APP_LICENSE_API || 'https://glitchcloud.app/license-api';

/**
 * Fetch vers le serveur scanner.
 * Essaie d'abord le chemin direct (rétro-compatible avec la prod).
 * Si CORS/réseau bloque (devtunnel, Mini-App), bascule sur le proxy license-server.
 */
export async function scannerFetch(
  vpsIp: string,
  vpsPort: string,
  path: string,
  options?: RequestInit,
): Promise<Response> {
  const directUrl = `https://${vpsIp}:${vpsPort}${path}`;
  try {
    const resp = await fetch(directUrl, {
      ...options,
      mode: 'cors',
      credentials: 'omit',
    });
    return resp;
  } catch {
    // Direct bloqué (CORS depuis devtunnel / Mini-App) → proxy server-side
    // La cible est dans l'URL pour éviter le header custom (et donc le preflight OPTIONS)
    const isBodyMethod = ['POST', 'PUT', 'PATCH'].includes(
      (options?.method || 'GET').toUpperCase(),
    );
    return fetch(`${LICENSE_API}/scanner-proxy/${vpsIp}/${vpsPort}${path}`, {
      ...options,
      headers: {
        ...(isBodyMethod ? { 'Content-Type': 'application/json' } : {}),
        ...(options?.headers || {}),
      },
    });
  }
}
